import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sector-analysis-page" }
const _hoisted_2 = { class: "analysis-shell" }
const _hoisted_3 = { class: "analysis-panel hero-panel" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = { class: "search-box" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "hero-metrics" }
const _hoisted_8 = { class: "sector-workspace" }
const _hoisted_9 = { class: "analysis-panel sector-list-panel" }
const _hoisted_10 = { class: "panel-header" }
const _hoisted_11 = { class: "result-count" }
const _hoisted_12 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_13 = {
  key: 1,
  class: "empty-state error-state"
}
const _hoisted_14 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_15 = {
  key: 3,
  class: "sector-grid"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sector-card-header" }
const _hoisted_18 = { class: "stock-count" }
const _hoisted_19 = { class: "sector-values" }
const _hoisted_20 = { class: "weight-row" }
const _hoisted_21 = { class: "weight-meta" }
const _hoisted_22 = { class: "weight-bar" }
const _hoisted_23 = {
  key: 0,
  class: "analysis-panel deep-dive-panel"
}
const _hoisted_24 = { class: "panel-header" }
const _hoisted_25 = { class: "deep-dive-summary" }
const _hoisted_26 = { class: "summary-pill" }
const _hoisted_27 = { class: "summary-pill" }
const _hoisted_28 = { class: "text-success" }
const _hoisted_29 = { class: "summary-pill" }
const _hoisted_30 = { class: "summary-pill" }
const _hoisted_31 = { class: "table-shell" }
const _hoisted_32 = { class: "table sector-stock-table" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "stock-name" }
const _hoisted_36 = { class: "range-stack" }
const _hoisted_37 = { class: "range-bar" }
const _hoisted_38 = { class: "badge-stack" }
const _hoisted_39 = {
  key: 0,
  class: "risk-badge neutral"
}
const _hoisted_40 = { class: "analysis-panel intelligence-panel" }
const _hoisted_41 = { class: "tab-strip" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "tab-panel"
}
const _hoisted_44 = { class: "chart-card" }
const _hoisted_45 = { class: "insight-list" }
const _hoisted_46 = {
  key: 0,
  class: "overweight-badge"
}
const _hoisted_47 = {
  key: 1,
  class: "tab-panel"
}
const _hoisted_48 = { class: "chart-card wide" }
const _hoisted_49 = {
  key: 2,
  class: "tab-panel"
}
const _hoisted_50 = { class: "heatmap" }
const _hoisted_51 = { class: "heatmap-sector" }
const _hoisted_52 = {
  key: 3,
  class: "tab-panel suggestions-panel"
}
const _hoisted_53 = {
  key: 0,
  class: "suggestion-grid"
}
const _hoisted_54 = { class: "suggestion-sector" }
const _hoisted_55 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doughnut = _resolveComponent("Doughnut")!
  const _component_Bar = _resolveComponent("Bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "hero-copy" }, [
          _createElementVNode("p", { class: "eyebrow" }, "Sector Analysis"),
          _createElementVNode("h2", null, "Portfolio strength by sector, with stock-level risk signals."),
          _createElementVNode("p", { class: "hero-description" }, " Click a sector card to open the deep dive. The dashboard uses your current portfolio stocks and sector master data. ")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-search" }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.searchTerm) = $event)),
              type: "text",
              placeholder: "Search sector by name"
            }, null, 512), [
              [
                _vModelText,
                $data.searchTerm,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "export-button",
            disabled: !$options.normalizedSectors.length || $data.isLoadingSectors,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.exportSectorAnalysis && $options.exportSectorAnalysis(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fa fa-download" }, null, -1),
            _createTextVNode(" Export sector report ", -1)
          ]))], 8, _hoisted_6),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _cache[5] || (_cache[5] = _createElementVNode("span", null, "Total Invested", -1)),
              _createElementVNode("strong", null, _toDisplayString($options.formatCurrency($options.totalInvested)), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Current Value", -1)),
              _createElementVNode("strong", null, _toDisplayString($options.formatCurrency($options.totalCurrentValue)), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("span", null, "Portfolio P&L", -1)),
              _createElementVNode("strong", {
                class: _normalizeClass($options.getTextClass($options.totalPlPercent))
              }, _toDisplayString($options.formatSignedCurrency($options.totalPlAmount)), 3)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("div", null, [
              _createElementVNode("p", { class: "section-kicker" }, "Section 1"),
              _createElementVNode("h3", null, "Sector Summary Cards")
            ], -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString($options.filteredSectors.length) + " sectors", 1)
          ]),
          ($data.isLoadingSectors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Loading sector summary... "))
            : ($data.loadError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($data.loadError), 1))
              : (!$options.filteredSectors.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _cache[10] || (_cache[10] = _createTextVNode(" No sectors matched \"", -1)),
                    _createElementVNode("strong", null, _toDisplayString($data.searchTerm), 1),
                    _cache[11] || (_cache[11] = _createTextVNode("\". ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredSectors, (sector) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: sector.sectorName,
                        type: "button",
                        class: _normalizeClass(["sector-card", [{ active: $options.selectedSector?.sectorName === sector.sectorName }, $options.getCardClass(sector)]]),
                        onClick: ($event: any) => ($options.selectSector(sector))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(sector.sectorName), 1),
                            _createElementVNode("p", null, _toDisplayString($options.formatCurrency(sector.totalInvested)) + " invested", 1)
                          ]),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(sector.stocks.length) + " stocks", 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Current Value", -1)),
                            _createElementVNode("strong", null, _toDisplayString($options.formatCurrency(sector.currentValue)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("span", null, "P&L", -1)),
                            _createElementVNode("strong", {
                              class: _normalizeClass($options.getTextClass(sector.plPercent))
                            }, _toDisplayString($options.getArrow(sector.plPercent)) + " " + _toDisplayString($options.formatSignedCurrency(sector.plAmount)), 3),
                            _createElementVNode("small", {
                              class: _normalizeClass($options.getTextClass(sector.plPercent))
                            }, _toDisplayString($options.formatPercent(sector.plPercent)), 3)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Portfolio Weight", -1)),
                            _createElementVNode("strong", null, _toDisplayString($options.formatPercent(sector.portfolioWeight)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "weight-fill",
                              style: _normalizeStyle({ width: `${Math.min(sector.portfolioWeight, 100)}%` })
                            }, null, 4)
                          ])
                        ])
                      ], 10, _hoisted_16))
                    }), 128))
                  ]))
        ]),
        ($options.selectedSector)
          ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _cache[15] || (_cache[15] = _createElementVNode("p", { class: "section-kicker" }, "Section 2", -1)),
                  _createElementVNode("h3", null, _toDisplayString($options.selectedSector.sectorName) + " Deep Dive", 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "route-link",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.openSectorStocks($options.selectedSector)))
                }, "Open matching stocks")
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", null, "Stocks", -1)),
                  _createElementVNode("strong", null, _toDisplayString($options.selectedSector.stocks.length), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", null, "Best P&L", -1)),
                  _createElementVNode("strong", _hoisted_28, _toDisplayString($options.formatPercent($options.selectedSectorTopPerformer.plPercent)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", null, "Avg 52W Position", -1)),
                  _createElementVNode("strong", null, _toDisplayString($options.formatPercent($options.selectedSectorRisk.avg52WPosition)), 1)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", null, "Penny Stocks", -1)),
                  _createElementVNode("strong", null, _toDisplayString($options.selectedSectorRisk.pennyStockCount), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("table", _hoisted_32, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.stockHeaders, (header) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: header.key,
                          class: _normalizeClass({ sortable: header.sortable, active: $data.stockSort.key === header.key }),
                          onClick: ($event: any) => (header.sortable && $options.sortStocks(header.key))
                        }, [
                          _createTextVNode(_toDisplayString(header.label) + " ", 1),
                          (header.sortable && $data.stockSort.key === header.key)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString($data.stockSort.order === 'desc' ? 'v' : '^'), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_33))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedSelectedStocks, (stock) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: stock.code,
                        class: _normalizeClass({ 'exit-row': stock.plPercent < -40 })
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("strong", null, _toDisplayString(stock.name), 1),
                            _createElementVNode("small", null, _toDisplayString(stock.code), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString($options.formatCurrency(stock.invested)), 1),
                        _createElementVNode("td", null, _toDisplayString($options.formatCurrency(stock.currentValue)), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass($options.getTextClass(stock.plPercent))
                        }, _toDisplayString($options.formatPercent(stock.plPercent)), 3),
                        _createElementVNode("td", null, _toDisplayString($options.formatCurrency(stock.week52Low)), 1),
                        _createElementVNode("td", null, _toDisplayString($options.formatCurrency(stock.week52High)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", {
                                class: "range-fill",
                                style: _normalizeStyle({ width: `${$options.get52WPosition(stock)}%` })
                              }, null, 4)
                            ]),
                            _createElementVNode("small", null, _toDisplayString($options.formatPercent($options.get52WPosition(stock))), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getRiskBadges(stock), (badge) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: `${stock.code}-${badge}`,
                                class: _normalizeClass(["risk-badge", $options.getRiskBadgeClass(badge)])
                              }, _toDisplayString(badge), 3))
                            }), 128)),
                            (!$options.getRiskBadges(stock).length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Stable"))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("section", _hoisted_40, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "panel-header" }, [
          _createElementVNode("div", null, [
            _createElementVNode("p", { class: "section-kicker" }, "Section 3"),
            _createElementVNode("h3", null, "Sector Intelligence Panel")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.intelligenceTabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.key,
              type: "button",
              class: _normalizeClass(["tab-button", { active: $data.activeTab === tab.key }]),
              onClick: ($event: any) => ($data.activeTab = tab.key)
            }, _toDisplayString(tab.label), 11, _hoisted_42))
          }), 128))
        ]),
        ($data.activeTab === 'allocation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_Doughnut, {
                  data: $options.allocationChartData,
                  options: $options.allocationChartOptions
                }, null, 8, ["data", "options"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.normalizedSectors, (sector) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `allocation-${sector.sectorName}`,
                    class: "insight-row"
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(sector.sectorName), 1),
                      _createElementVNode("p", null, _toDisplayString($options.formatPercent(sector.portfolioWeight)) + " of portfolio", 1)
                    ]),
                    (sector.portfolioWeight > 15)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Overweight"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : ($data.activeTab === 'performance')
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(_component_Bar, {
                    data: $options.performanceChartData,
                    options: $options.performanceChartOptions
                  }, null, 8, ["data", "options"])
                ])
              ]))
            : ($data.activeTab === 'risk')
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "heatmap-header" }, "Sector", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.heatmapColumns, (column) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `header-${column.key}`,
                        class: "heatmap-header"
                      }, _toDisplayString(column.label), 1))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.heatmapRows, (row) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: row.sectorName
                      }, [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(row.sectorName), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.heatmapColumns, (column) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${row.sectorName}-${column.key}`,
                            class: _normalizeClass(["heatmap-cell", $options.getHeatLevelClass(row[column.key].level)])
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(row[column.key].level), 1),
                            _createElementVNode("small", null, _toDisplayString(row[column.key].value), 1)
                          ], 2))
                        }), 128))
                      ], 64))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  ($options.suggestionCards.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.suggestionCards, (suggestion) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `${suggestion.sector}-${suggestion.title}`,
                            class: "suggestion-card"
                          }, [
                            _createElementVNode("p", _hoisted_54, _toDisplayString(suggestion.sector), 1),
                            _createElementVNode("h4", null, _toDisplayString(suggestion.title), 1),
                            _createElementVNode("p", null, _toDisplayString(suggestion.message), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, " No sector suggestions for the current portfolio. "))
                ]))
      ])
    ])
  ]))
}